import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRTest = () => {
  const qrUrl = "https://edos.vdcapp.in/";

  return (
    <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h2>Scan to Open EDOS</h2>

      <div
        style={{
          background: "white",
          padding: "16px",
          display: "inline-block",
          borderRadius: "12px"
        }}
      >
        <QRCodeCanvas
          value={qrUrl}
          size={220}
          fgColor="#000000"
          bgColor="#ffffff"
          level="H"
          imageSettings={{
            src: "/assets/images/vdc_logo.png", // your logo
            height: 50,
            width: 50,
            excavate: true,
          }}
        />
      </div>

      <p style={{ marginTop: "10px", fontSize: "14px" }}>{qrUrl}</p>
    </div>
  );
};

export default QRTest;
